<template>
  <div>
    <div v-if="loading">
      <p>Cargando..</p>
    </div>
    <div class="mb-8 flex justify-start max-w-3xl">
      <h1 class="font-bold text-3xl">
        <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('applicationbuy.editCost',form.idBuy)">Regresar</inertia-link>
        <span class="text-indigo-400 font-medium">/</span>
        Precio
      </h1>
     
    </div>
    <div class="flex flex-wrap">
    <div class="w-full">
    
      <div class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
        
        <div class="px-4 py-5 flex-auto">
          <div class="tab-content tab-space">
      
              <form @submit.prevent="store">
              <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                <text-input v-model="form.id" :error="form.errors.id" :req="form.id" class="pb-8 pr-6 w-full lg:w-1/6" label="Id" disabled/>   
                <text-input v-model="form.amount" :error="form.errors.amount" :req="form.amount" class="pb-8 pr-6 w-full lg:w-1/6" label="Cantidad" disabled/>   
                <text-input v-model="form.article" :error="form.errors.article" :req="form.name" class="pb-8 pr-6 w-full lg:w-2/6" label="Activo" disabled/>
                <select-input v-model="form.iva" :error="form.errors.iva" :req="form.iva" class="pr-6 pb-8 w-full lg:w-1/6" label="Iva" required>
            <option>0</option>
            <option>5</option>
            <option>12</option>
            <option>15</option>
          </select-input>                <text-input v-model="form.total" :error="form.errors.total" :req="form.total" class="pb-8 pr-6 w-full lg:w-1/6" label="Precio" required/>   

                </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Guardar</loading-button>
        </div>
      </form>
                   
          </div>
        </div>
       
      </div>
    </div>
  </div>
  <preloader />
  </div>
  
</template>

<script>
import Layout from '@/Shared/LayoutMenu'
import FileInput from '@/Shared/FileInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import TextareaInput from '@/Shared/TextareaInput'
import TextInput from '@/Shared/TextInput'

export default {
  metaInfo: { title: 'Costos' },
  components: {
    FileInput,
    LoadingButton,
    SelectInput,
    TextInput,
    vSelect,
    DatePicker,
    TextareaInput,
  },
  layout: Layout,
  props: {
    applicationDetail: Object,
  },
  remember: 'form',
  data() {
    return {
       loading: true,
      form: this.$inertia.form({
        idBuy: this.applicationDetail.applicationbuy_id,
        id: this.applicationDetail.id,
        amount: this.applicationDetail.amount,
        article: this.applicationDetail.name,
        iva: this.applicationDetail.iva,
        total: this.applicationDetail.total,
             
      }),
    }
  },
 
  methods: {
    store() {
      
      this.form.post('/storeCostUpdate')
    },
   
  },
}
</script>